import React from "react";

import { UserRoles } from "./common/types/types";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import withSuspense from "./withSuspense/withSuspense";

const Breeds = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Breeds/Breeds"))
);

const Breed = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Breeds/Breed/Breed"))
);

const Services = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Services/Services"))
);

const ServiceGroups = withSuspense(
  React.lazy(
    async () => await import("./pages/sysAdmin/ServiceGroups/ServiceGroups")
  )
);

const ServiceGroup = withSuspense(
  React.lazy(
    async () =>
      await import(
        "./pages/sysAdmin/ServiceGroups/DisplayServiceGroup/DisplayServiceGroup"
      )
  )
);

const Service = withSuspense(
  React.lazy(
    async () => await import("./pages/sysAdmin/Services/Service/Service")
  )
);

const SysAdminCompanies = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Companies/Companies"))
);

const AdminCompanies = withSuspense(
  React.lazy(async () => await import("./pages/admin/Companies/Companies"))
);

const OprCompanies = withSuspense(
  React.lazy(async () => await import("./pages/opr/Companies/Companies"))
);

//admin and sysAdmin share Company detail page
const Company = withSuspense(
  React.lazy(async () => await import("./pages/Company/Company"))
);

const OprCompany = withSuspense(
  React.lazy(async () => await import("./pages/opr/Companies/Company/Company"))
);

const SysAdminUsers = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Users/Users"))
);

const AdminUsers = withSuspense(
  React.lazy(async () => await import("./pages/admin/Users/Users"))
);

const AdminNannyUsers = withSuspense(
  React.lazy(async () => await import("./pages/admin/NannyUsers/NannyUsers"))
);

const AdminNannyBranches = withSuspense(
  React.lazy(
    async () => await import("./pages/admin/NannyBranches/NannyBranches")
  )
);

const AdminNannyBranch = withSuspense(
  React.lazy(
    async () =>
      await import(
        "./pages/admin/NannyBranches/DisplayNannyBranch/DisplayNannyBranch"
      )
  )
);

const SysAdminUser = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Users/User/User"))
);

const AdminUser = withSuspense(
  React.lazy(async () => await import("./pages/admin/Users/User/User"))
);

const Support = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Support/Support"))
);

const Marketing = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Marketing/Marketing"))
);

const MarketingGroups = withSuspense(
  React.lazy(
    async () => await import("./pages/sysAdmin/MarketingGroups/MarketingGroups")
  )
);

const DisplayMarketing = withSuspense(
  React.lazy(
    async () =>
      await import(
        "./pages/sysAdmin/Marketing/DisplayMarketing/DisplayMarketing"
      )
  )
);
const MarketingGroup = withSuspense(
  React.lazy(
    async () =>
      await import(
        "./pages/sysAdmin/MarketingGroups/DisplayMarketingGroup/DisplayMarketingGroup"
      )
  )
);

const Faq = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Faq/Faq"))
);

const DisplayFaq = withSuspense(
  React.lazy(
    async () => await import("./pages/sysAdmin/Faq/DisplayFaq/DisplayFaq")
  )
);

const PrivacyPolicy = withSuspense(
  React.lazy(
    async () => await import("./pages/sysAdmin/PrivacyPolicy/PrivacyPolicy")
  )
);
const TermsOfUse = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/TermsOfUse/TermsOfUse"))
);

const NotificationSender = withSuspense(
  React.lazy(
    async () =>
      await import("./pages/sysAdmin/NotificationSender/NotificationSender")
  )
);

const Login = withSuspense(
  React.lazy(async () => await import("./pages/Login/Login"))
);

const Dashboard = withSuspense(
  React.lazy(async () => await import("./pages/Dashboard/Dashboard"))
);

const AnimalTypes = withSuspense(
  React.lazy(
    async () => await import("./pages/sysAdmin/AnimalTypes/AnimalTypes")
  )
);

const AnimalType = withSuspense(
  React.lazy(
    async () =>
      await import("./pages/sysAdmin/AnimalTypes/AnimalType/AnimalType")
  )
);

const UserSettings = withSuspense(
  React.lazy(async () => await import("./pages/UserSettings/UserSettings"))
);

const Bookings = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Bookings/Bookings"))
);

const AdminBookings = withSuspense(
  React.lazy(async () => await import("./pages/admin/Bookings/Bookings"))
);

const DisplayBooking = withSuspense(
  React.lazy(
    async () => await import("./pages/Bookings/DisplayBooking/DisplayBooking")
  )
);

const CompanyBranches = withSuspense(
  React.lazy(
    async () => await import("./pages/admin/CompanyBranches/CompanyBranches")
  )
);

const CompanyBranch = withSuspense(
  React.lazy(
    async () =>
      await import(
        "./pages/admin/CompanyBranches/DisplayCompanyBranch/DisplayCompanyBranch"
      )
  )
);
const Payments = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Payments/Payments"))
);

const DisplayPayment = withSuspense(
  React.lazy(
    async () =>
      await import("./pages/sysAdmin/Payments/DisplayPayment/DisplayPayment")
  )
);

const Reviews = withSuspense(
  React.lazy(async () => await import("./pages/Reviews/Reviews"))
);

const Home = withSuspense(
  React.lazy(async () => await import("./pages/sysAdmin/Home/Home"))
);

const AdminHome = withSuspense(
  React.lazy(async () => await import("./pages/admin/Home/Home"))
);

const useRoutesList = () => {
  const routesList = [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute
          availableForRoles={[
            UserRoles.sysAdmin,
            UserRoles.admin,
            UserRoles.opr,
          ]}
        >
          <Dashboard />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "home",
          element: (
            <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
              <Home />
            </ProtectedRoute>
          ),
        },
        {
          path: "admin-home",
          element: (
            <ProtectedRoute availableForRoles={[UserRoles.admin]}>
              <AdminHome />
            </ProtectedRoute>
          ),
        },
        {
          path: "userSettings",
          element: <UserSettings />,
        },
        {
          path: "companies",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <SysAdminCompanies />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <Company />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "company",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                  <AdminCompanies />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <Company />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "company-operator",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.opr]}>
                  <OprCompanies />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <OprCompany />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "service-groups",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <ServiceGroups />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                      <ServiceGroup />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "marketing-groups",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <MarketingGroups />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                      <MarketingGroup />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "services",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <Services />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <Service />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "breeds",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <Breeds />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <Breed />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "animalTypes",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <AnimalTypes />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <AnimalType />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "users",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <SysAdminUsers />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <SysAdminUser />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "bookings",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <Bookings />
                </ProtectedRoute>
              ),
              index: true,
            },

            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute
                      availableForRoles={[
                        UserRoles.sysAdmin,
                        UserRoles.admin,
                        UserRoles.opr,
                      ]}
                    >
                      <DisplayBooking />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "company-bookings",
          children: [
            {
              element: (
                <ProtectedRoute
                  availableForRoles={[UserRoles.admin, UserRoles.opr]}
                >
                  <AdminBookings />
                </ProtectedRoute>
              ),
              index: true,
            },

            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute
                      availableForRoles={[
                        UserRoles.sysAdmin,
                        UserRoles.admin,
                        UserRoles.opr,
                      ]}
                    >
                      <DisplayBooking />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "reviews",
          children: [
            {
              element: (
                <ProtectedRoute
                  availableForRoles={[
                    UserRoles.sysAdmin,
                    UserRoles.admin,
                    UserRoles.opr,
                  ]}
                >
                  <Reviews />
                </ProtectedRoute>
              ),
              index: true,
            },
          ],
        },
        {
          path: "company-branches",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                  <CompanyBranches />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                      <CompanyBranch />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
            {
              path: "new",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                      <CompanyBranch />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "company-users",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                  <AdminUsers />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: <AdminUser />,
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "nannies",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                  <AdminNannyUsers />
                </ProtectedRoute>
              ),
              index: true,
            },
          ],
        },
        {
          path: "nanny-branches",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                  <AdminNannyBranches />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                      <AdminNannyBranch />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
            {
              path: "new",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.admin]}>
                      <AdminNannyBranch />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "support",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <Support />
                </ProtectedRoute>
              ),
              index: true,
            },
          ],
        },
        {
          path: "marketing",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <Marketing />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                      <DisplayMarketing />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "payments",
          children: [
            {
              element: (
                <ProtectedRoute
                  availableForRoles={[UserRoles.sysAdmin, UserRoles.admin]}
                >
                  <Payments />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute
                      availableForRoles={[UserRoles.sysAdmin, UserRoles.admin]}
                    >
                      <DisplayPayment />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "faq",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <Faq />
                </ProtectedRoute>
              ),
              index: true,
            },
            {
              path: ":id",
              children: [
                {
                  element: (
                    <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                      <DisplayFaq />
                    </ProtectedRoute>
                  ),
                  index: true,
                },
              ],
            },
          ],
        },
        {
          path: "privacyPolicy",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <PrivacyPolicy />
                </ProtectedRoute>
              ),
              index: true,
            },
          ],
        },
        {
          path: "termsOfUse",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <TermsOfUse />
                </ProtectedRoute>
              ),
              index: true,
            },
          ],
        },
        {
          path: "notification-sender",
          children: [
            {
              element: (
                <ProtectedRoute availableForRoles={[UserRoles.sysAdmin]}>
                  <NotificationSender />
                </ProtectedRoute>
              ),
              index: true,
            },
          ],
        },
      ],
    },
  ];
  return routesList;
};

export default useRoutesList;
